import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { Icon, Loader } from '@fourthwall/components'

import * as S from './Overlay.styled'

type Props = {
  type?: 'default' | 'error'
  title?: string
  subTitle?: string
  showLoader?: boolean
  icon?: IconComponent
}

export const Overlay = ({ type = 'default', title, subTitle, icon, showLoader = true }: Props) => {
  return (
    <>
      {type === 'default' && <S.Overlay data-testid="Overlay" />}
      {type === 'error' && <S.ErrorOverlay />}
      <S.Container>
        {showLoader && (
          <S.IconContainer>
            <Loader size="large" appearance="primary" />
          </S.IconContainer>
        )}
        {icon && (
          <S.IconContainer>
            <Icon component={icon} height={23} />
          </S.IconContainer>
        )}
        {title && <S.Title>{title}</S.Title>}
        {subTitle && <S.SubTitle>{subTitle}</S.SubTitle>}
      </S.Container>
    </>
  )
}
